const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/weight.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/weight.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { defaultWeightDateRange } from '@/features/weight-tracking/lib/date-range';
import { getLatestWeightQuery } from '@/features/weight-tracking/lib/get-latest-weight.query';
import { getWeightSeriesQuery } from '@/features/weight-tracking/lib/get-weight-series.query';
export const Route = createFileRoute('/_authenticated/tracking/weight')({
  loader: async ({
    context,
    location
  }) => {
    const range = defaultWeightDateRange();
    const deps = {
      controllers: {
        weightTrackingController: context.deps.controllers.weightTrackingController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureQueryData(getLatestWeightQuery(deps)), context.queryClient.ensureQueryData(getWeightSeriesQuery(deps, range))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});